import { SearchField, MultiValueSearchField } from '../Query';

export const isMultiValueSearchField = (
  searchField?: SearchField,
): searchField is MultiValueSearchField =>
  !!searchField && 'values' in searchField && Array.isArray(searchField.values);
